<template>
    <div v-if="filters.length">
        <div v-if="!isTabletSmall" class="filter">
            <div
                v-for="(filter, index) in filters"
                :key="filter.serviceGroupId"
                :class="classList(filter)"
                @click="changeActiveFilter(filter)"
            >
                {{ getServiceGroupName(index) }}
            </div>
        </div>
        <div v-else class="filter-select">
            <select class="filter-select--input" @change="onChange($event)">
                <option v-for="(filter, index) in filters" :key="filter.serviceGroupId" :value="filter.serviceGroupId">
                    {{ getServiceGroupName(index) }}
                </option>
            </select>
        </div>
    </div>
</template>

<script>
    import OfferAPI from 'api/OfferAPI'
    import LanguageEnum from 'enums/language.enum'
    import cloneDeep from 'lodash.clonedeep'
    import WindowResizeMixin from 'mixins/WindowResizeMixin'
    import Store from '~/store'

    export default {
        mixins: [WindowResizeMixin],

        data() {
            return {
                filters: [],
                activeFilter: {
                    serviceGroupId: 0,
                    serviceGroupName: this.$t('common.microcopy.all'),
                    serviceGroupNameSR: this.$t('common.microcopy.all'),
                    serviceGroupNameRU: this.$t('common.microcopy.all'),
                    serviceGroupNameBIH: this.$t('common.microcopy.all'),
                },
                activeFilterId: 0,
            }
        },

        computed: {
            countryByGeolocation() {
                return Store.getters['data/getCountryByGeolocation'] ?? 0
            },
        },

        methods: {
            getMostPopularFilters() {
                OfferAPI.findMostPopularServices(this.countryByGeolocation).then((response) => {
                    this.filters = response.splice(0, 3)
                    this.filters.unshift(this.activeFilter)
                })
            },

            classList(filter) {
                return {
                    'filter--item': true,
                    'filter--item__active': filter.serviceGroupId === this.activeFilterId,
                }
            },

            getServiceGroupName(index) {
                return this.$i18n.locale === LanguageEnum.EN
                    ? this.filters[index].serviceGroupName
                    : this.filters[index][`serviceGroupName${this.$i18n.locale.toUpperCase()}`]
            },

            changeActiveFilter(filter) {
                this.activeFilter = cloneDeep(filter)
                this.activeFilterId = filter.serviceGroupId
                this.emitEvent({ name: 'filter-changed', payload: cloneDeep(this.activeFilter) })
            },

            onChange(filter) {
                this.emitEvent({ name: 'filter-changed', payload: { serviceGroupId: Number(filter.target.value) } })
            },
        },

        watch: {
            '$i18n.locale': {
                handler: function () {
                    this.activeFilter = {
                        serviceGroupId: 0,
                        serviceGroupName: this.$t('common.microcopy.all'),
                        serviceGroupNameSR: this.$t('common.microcopy.all'),
                        serviceGroupNameRU: this.$t('common.microcopy.all'),
                        serviceGroupNameBIH: this.$t('common.microcopy.all'),
                    }
                    this.getMostPopularFilters()
                },
            },

            countryByGeolocation() {
                this.getMostPopularFilters()
            },
        },

        mounted() {
            this.getMostPopularFilters()
        },
    }
</script>

<style scoped lang="scss">
    @import 'styles/setup/_variables.scss';
    @import 'styles/setup/_mixins.scss';
    .filter {
        display: flex;
        flex-wrap: wrap;
        justify-content: flex-end;
        margin-bottom: 10px;
        &--item {
            @include breakpoint(tablet-small) {
                width: 100%;
            }
            font-family: 'Poppins';
            font-style: normal;
            font-weight: 400;
            font-size: 16px;
            line-height: 28px;
            margin-left: 14px;
            color: $color--txt-base-3;
            cursor: pointer;

            &__active,
            &:hover {
                color: $color--txt-base;
            }
        }
    }

    .filter-select {
        display: flex;
        justify-content: flex-end;

        margin-top: -15px;
        margin-bottom: 10px;
        &--input {
            width: auto;
            height: 30px;
            color: $color--txt-header-1;
            border-radius: 10px;
            transition: border-color 0.2s ease-in-out;
        }
    }
</style>
